import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api.service';
import { from, Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class ApiGatewayRoutesService extends ApiService {
  override getUrl() {
    this.url = environment.apiGatewayRoutes.url;
  }
  protected override buildHeaders(): Observable<any> {
    return from(this._storage.get('jwt')).pipe(mergeMap((jwt: any) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'jwt': jwt || 'no-jwt',
        }),
      };
      return of(httpOptions);
    }));
  }
}
